import React from 'react';
import useStepsProgress from 'utils/hooks/useStepsProgress';
import { Wrapper } from './styles';

const StepsProgressBar = () => {
  const { progressValue } = useStepsProgress();
  return <Wrapper progress={progressValue} />;
};

export default StepsProgressBar;
